<script>
import resources from './resources'

export default {
  name: 'professional-locks-form',
  mixins: [resources],
  data () {
    return {
      date: new Date(),
      config: {
        locale: 'pt-br',
        format: 'DD/MM/YYYY',
        useCurrent: false,
        widgetPositioning: {
          horizontal: 'left',
          vertical: 'bottom'
        }
      }
    }
  }
}
</script>

<template lang="pug">
page(title="Bloqueios na Agenda Profissional", icon="")
  .col-xs-12.content
    .container-fluid
      medibook-alert-custom(
        :show='show',
        @close='show = false',
        title='Perfeito',
        type='sa-success',
        message='Bloqueio incluido com sucesso.',
        :buttonsNext='nextStepButtonsRules',
        v-if="wasRaised")

      .row
        ul.nav.nav-tabs
          li
            router-link(:to="{ name: 'professional.agenda.locks.index'}")
             a(href="#") Listagem
          li.active
             a(href="#") Cadastro

        .col-xs-12.white-bg
          .row
            .col-xs-12
              div.col-sm-10
                h4 AGENDA PROFISSIONAL — BLOQUEIOS
                .form-group
                  .row
                    .col-xs-12
                      v-input(:status="$v.lock.name.$error ? 'error' : null")
                        f-text(
                         label="Nome do Bloqueio (Congressos, Eventos, Viagens, etc.)"
                         name="name",
                         v-model="lock.name",
                         :errors="errors['name']")

                .form-group
                  .row
                    .col-xs-12
                      v-input(:status="$v.lock.lock_type_id.$error ? 'error' : null")
                        f-select-agenda-lock-type(label="Tipo"
                          name="lock.lock_type_id",
                          v-model="lock.lock_type_id",
                          :get-all="true",
                          :errors="errors['lock_type_id']")

                .row
                  .form-group.col-xs-12.col-sm-3.margin-bottom
                    v-input(:status="$v.lock.date_start.$error ? 'error' : null")
                      label Data Inicial
                      v-datepicker(
                        v-model="lock.date_start",
                        name="date_start",
                        :config='config')

                  .form-group.col-xs-12.col-sm-3.margin-bottom
                    v-input(:status="$v.lock.time_start.$error ? 'error' : null")
                      f-time(label="Hora Inicial"
                        name="time_start",
                        v-model="lock.time_start",
                        :errors="errors['date_start']"
                        placeholder="00:00")

                  .form-group.col-xs-12.col-sm-3.margin-bottom
                    v-input(:status="$v.lock.date_end.$error ? 'error' : null")
                      label Data Final
                      v-datepicker(
                        v-model="lock.date_end",
                        name="date_end",
                        :config='config')

                  .form-group.col-xs-12.col-sm-3.margin-bottom
                    v-input(:status="$v.lock.time_end.$error ? 'error' : null")
                      f-time(label="Hora Final"
                        name="time_end",
                        v-model="lock.time_end",
                        :errors="errors['date_end']"
                        placeholder="00:00")

                .form-group(v-if="userIsCompany")
                  .row
                    .col-xs-12
                       f-select-company-professional(
                         label="Profissional (Opcional)",
                         name="professional_id",
                         v-model="lock.professional_id",
                         :get-all="true",
                         :searchable="true",
                         :errors="errors['professional_id']")

                .buttons-wrapper
                  button.btn.save(@click.prevent="doSave()")
                    span.icon 
                    |  Salvar Alterações
</template>



// WEBPACK FOOTER //
// src/app/professional/agenda/locks/form/form.vue